import katex from 'katex';
import 'katex/dist/katex.min.css';

function splitTranscriptionLines(text) {
  return text.split(/\\\\(?:[ \t]*\r?\n)?|\r?\n/);
}

function TranscriptionMathRenderer({ content }) {
  const text = content === null || content === undefined ? '' : String(content);

  try {
    const renderedLines = splitTranscriptionLines(text).map((line) =>
      katex.renderToString(line, {
        displayMode: true,
        throwOnError: true,
        strict: 'warn',
      })
    );

    return (
      <div className="transcription-review-text transcription-review-math">
        {renderedLines.map((html, index) => (
          <div
            key={index}
            className="transcription-review-math-line"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ))}
      </div>
    );
  } catch (error) {
    return <pre className="transcription-review-text">{text}</pre>;
  }
}

export default TranscriptionMathRenderer;
